<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  <nb-option [value]="null">Alle</nb-option>
  @for (type of EmailTypes(); track type) {
    <nb-option [value]="type">
      {{ type | emailTypeTranslation }}
    </nb-option>
  }
</nb-select>
